import { render, staticRenderFns } from "./SurvivorAgeGroup.vue?vue&type=template&id=6a6f943a&scoped=true"
import script from "./SurvivorAgeGroup.vue?vue&type=script&lang=js"
export * from "./SurvivorAgeGroup.vue?vue&type=script&lang=js"
import style0 from "./SurvivorAgeGroup.vue?vue&type=style&index=0&id=6a6f943a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6f943a",
  null
  
)

export default component.exports